import script from "./Volume.vue?vue&type=script&setup=true&lang=js"
export * from "./Volume.vue?vue&type=script&setup=true&lang=js"

import "./Volume.vue?vue&type=style&index=0&id=96c4ea56&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96c4ea56"]])

export default __exports__